import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Esito } from '../../../models/esito';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { EsitiModAutoAddScadenzeFormComponent } from './esiti-mod-auto-add-scadenze-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  moduleId: module.id.replace('/dist/', '/'),
  selector: 'div [esiti-mod-auto-add-scadenze]',
  templateUrl: 'esiti-mod-auto-add-scadenze.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class EsitiModAutoAddScadenzeComponent {

    @Output()
    onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

    @ViewChild('esitiModAutoAddScadenzeForm')
    esitiModAutoAddScadenzeForm: EsitiModAutoAddScadenzeFormComponent;

    inizializza(esitoIns: Esito, urlAddScadenza: string, idSezione: string, fascicolo: FascicoloFull, tipoPratica: string, tipoFascicolo: string) {
        openModal('modalAutoaddScadenzeEsiti');
        this.esitiModAutoAddScadenzeForm.inizializza(esitoIns, urlAddScadenza, idSezione, fascicolo,  tipoPratica, tipoFascicolo);
    }

    manageModal() {
        closeModal('modalAutoaddScadenzeEsiti');
        this.onReturn.emit();
    }
}
